// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomOtherProfessionalsRelationshipsItem from './data'

export default function DataVaxiomOtherProfessionalsRelationshipsItemFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem">
      <DataVaxiomOtherProfessionalsRelationshipsItem {...props}>
        {children}
      </DataVaxiomOtherProfessionalsRelationshipsItem>
    </Flow>
  )
}
